import { CustomConfig, Field } from "../models/CustomConfig"
import { createContext } from "react"

export const ConfigContext = createContext<CustomConfig | null>(null)

// const configContext = React.createContext<CustomConfigContext | null>(null)

export const CustomFieldContext = createContext<Field | null>(null)
